import React, { useEffect, useState } from 'react';
import '../App.css';
import './home.css';

// Cooler, more realistic analog clock component
function AnalogClock({ size = 200 }) {
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setDate(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const sec = date.getSeconds();
  const min = date.getMinutes();
  const hour = date.getHours() % 12;

  const secAngle = sec * 6;
  const minAngle = min * 6;
  const hourAngle = (hour + min / 60) * 30;
  const center = size / 2;

  // Helper for clock ticks
  const ticks = [];
  for (let i = 0; i < 60; i++) {
    const isHour = i % 5 === 0;
    ticks.push(
      <rect
        key={i}
        x={center - (isHour ? 3 : 1)}
        y={24}
        width={isHour ? 6 : 2}
        height={isHour ? 18 : 10}
        fill={isHour ? "#86868b" : "#bdbdbd"}
        opacity={isHour ? 1 : 0.7}
        rx={2}
        transform={`rotate(${i * 6} ${center} ${center})`}
      />
    );
  }

  return (
    <svg
      className="analog-clock"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      style={{ display: 'block' }}
    >
      {/* Outer glassy face */}
      <circle
        cx={center}
        cy={center}
        r={center - 4}
        fill="url(#clockFaceGradient)"
        stroke="#e9ebee"
        strokeWidth="4"
        filter="url(#clockShadow)"
      />
      <defs>
        <radialGradient id="clockFaceGradient" cx="60%" cy="40%" r="80%">
          <stop offset="0%" stopColor="#fff" />
          <stop offset="70%" stopColor="#f5f6fa" />
          <stop offset="100%" stopColor="#e9ebee" />
        </radialGradient>
        <filter id="clockShadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="4" stdDeviation="6" floodColor="#b3b3b3" floodOpacity="0.12" />
        </filter>
      </defs>
      {/* Ticks */}
      {ticks}
      {/* Hour hand */}
      <rect
        x={center - 6 / 2}
        y={center - 60}
        width={6}
        height={60}
        rx={3}
        fill="#223047"
        transform={`rotate(${hourAngle} ${center} ${center})`}
        style={{ transition: 'transform 0.2s cubic-bezier(.4,2,.6,1)' }}
      />
      {/* Minute hand */}
      <rect
        x={center - 4 / 2}
        y={center - 90}
        width={4}
        height={90}
        rx={2}
        fill="#0071e3"
        transform={`rotate(${minAngle} ${center} ${center})`}
        style={{ transition: 'transform 0.2s cubic-bezier(.4,2,.6,1)' }}
      />
      {/* Second hand */}
      <rect
        x={center - 1}
        y={center - 100}
        width={2}
        height={100}
        rx={1}
        fill="#f9b233"
        transform={`rotate(${secAngle} ${center} ${center})`}
        style={{ transition: 'transform 0.1s linear' }}
      />
      {/* Center circle */}
      <circle
        cx={center}
        cy={center}
        r="12"
        fill="#fff"
        stroke="#0071e3"
        strokeWidth="4"
        filter="url(#clockShadow)"
      />
      <circle cx={center} cy={center} r="5" fill="#0071e3" />
    </svg>
  );
}

function Home() {
  const [forecast, setForecast] = useState(null);
  const [now, setNow] = useState(new Date());

  // Fetch 5-day forecast from OpenWeatherMap
  useEffect(() => {
    const API_KEY = '4c38f3f0bc92c0be57cd8c2aeac74dc1';
    const LAT = 53.23398;
    const LON = 6.53937;

    fetch(
      `https://api.openweathermap.org/data/2.5/forecast?lat=${LAT}&lon=${LON}&units=metric&lang=nl&appid=${API_KEY}`
    )
      .then(res => res.json())
      .then(data => {
        if (!data.list) {
          setForecast(null);
          return;
        }
        const days = {};
        data.list.forEach(item => {
          const date = item.dt_txt.split(' ')[0];
          if (!days[date]) days[date] = [];
          days[date].push(item);
        });
        const forecastArr = Object.entries(days)
          .slice(0, 5)
          .map(([date, items]) => {
            const dayItem =
              items.find(i => i.weather[0].icon.endsWith('d')) || items[0];
            const temps = items.map(i => i.main.temp);
            const min = Math.min(...temps);
            const max = Math.max(...temps);
            const icon = dayItem.weather[0].icon;
            const desc = dayItem.weather[0].description;
            return { date, min, max, icon, desc };
          });
        setForecast(forecastArr);
      });
  }, []);

  // Update digital clock every second
  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="home-container">
      <div className="top-row">
        <div className="left-col">
          <div className="home-title-block">
            <h1>Welkom in Huize Sjaars</h1>
            <div className="home-subtext">
              <span>Trek een bak.</span>
            </div>
          </div>
          <div className="beer-block">
            <div className="beer-clock-row">
              <AnalogClock size={200} />
              <div className="beer-clock-info">
                <div className="beer-digital">
                  {now.toLocaleTimeString('nl-NL', {
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                  })}
                </div>
                <div className="beer-text">Het is tijd voor: <br />
                   een bak!</div>
              </div>
            </div>
          </div>
        </div>
        <div className="right-col">
          {/* Previously weather & map here; now moved below */}
        </div>
      </div>

      {/* Weather section (5-day forecast) */}
      <section className="weather-section">
        <h2>Het weer boven Huize Sjaars</h2>
        <div className="weather-days">
          {forecast ? (
            forecast.map(day => (
              <div className="weather-day" key={day.date}>
                <div className="weather-day-label">
                  {new Date(day.date).toLocaleDateString('nl-NL', {
                    weekday: 'short',
                  })}
                </div>
                <img
                  src={`https://openweathermap.org/img/wn/${day.icon}@2x.png`}
                  alt={day.desc}
                  title={day.desc}
                  style={{ width: 50, height: 50 }}
                />
                <div>
                  <span className="weather-temp-max">
                    {Math.round(day.max)}°
                  </span>
                  <span className="weather-temp-min">
                    /{Math.round(day.min)}°
                  </span>
                </div>
                <div style={{ fontSize: '0.9em', color: '#666' }}>
                  {day.desc}
                </div>
              </div>
            ))
          ) : (
            <div>Laden...</div>
          )}
        </div>
        <div className="weather-bottom-text">
          Het is vandaag:<br /> 
          perfect weer voor een bak
        </div>
      </section>

      {/* Map + text in the same block */}
      <div className="home-map-block">
        <iframe
          title="Huize Sjaars Location"
          width="1000"
          height="400"
          style={{ 
            border: 0, 
            borderRadius: '16px',
            maxWidth: '100%'
          }}
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2387.799217857863!2d6.5367992!3d53.2339872!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c9cd28d5c8bc49%3A0x55e51101673107dc!2sHuize%20Sjaars%20(HS)!5e0!3m2!1sen!2snl!4v1717680000000!5m2!1sen!2snl"
        />
        {/* New text added directly under the iframe */}
        <div className="map-text">
          <p>
            Trek een bak op deze locatie
          </p>
        </div>
      </div>
    </div>
  );
}

export default Home;
